var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "expert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MIA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quiz-Node",
    transform: "translate(-121.000000, -873.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "expert",
    transform: "translate(121.000000, 873.000000)",
    fill: "#C0C0C0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,12 C24,18.62736 18.62736,24 12,24 C5.37258,24 0,18.62736 0,12 C0,5.37258 5.37258,0 12,0 C18.62736,0 24,5.37258 24,12 Z M21.6,12 C21.6,17.30196 17.30196,21.6 12,21.6 C6.698064,21.6 2.4,17.30196 2.4,12 C2.4,6.698064 6.698064,2.4 12,2.4 C14.82984,2.4 17.3736,3.624384 19.13064,5.572296 L10.8,13.90296 L7.448532,10.55148 C6.979896,10.08288 6.220104,10.08288 5.751468,10.55148 C5.282844,11.02008 5.282844,11.77992 5.751468,12.24852 L9.102948,15.6 C10.04016,16.53732 11.55984,16.5372 12.49704,15.6 L20.5218,7.575312 C21.2106,8.899392 21.6,10.40424 21.6,12 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.dc318d4e541382a87d13d66b8524f973.svg";
export { ForwardRef as ReactComponent };